export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(161, 23, 23, .11)',
  type: 'light',
  primary: {
    main: '#274472',
    contrastText: '#FFFFFF',
    light: '#E9F3F6',
  },
  secondary: {
    main: '#FFFFFF',
    contrastText: '#092028',
  },
  text: {
    primary: '#2B2B2B',
    primaryLight: '#494949',
    secondary: '#697883',
    tertiary: '#494949',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    alternate: '#57D4FF',
  },
  divider: '#EDE4E8',
  background: {
    main: '#41688F',
    paper: '#FFF',
    default: '#FFF',
    footer: '#F8F8F8',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#274472',
    tableSubhead: '#EAE6E3',
    tableAlternate: '#F8E8E8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    benefits: '#F5F5F5',
    primary: '#0E2E3B',
    light: 'rgba(255, 200, 200, 0.3)',
  },
  surface: {
    gray: '#F8F8F8',
    header: '#F8F7F6',
  },
  verticalBar: {
    used: '#0E2E3B',
    unused: '#0E2E3B',
    unlimited: '#C0C0C0',
  },
};
